import { type TableView, type MailFolderTableQuery, isPriorityView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { isPrioritizeOnDemandEnabled } from 'owa-copilot-settings-utils';

export function shouldUseCustomHighPriorityView(tableView: TableView | undefined): boolean {
    return !!(
        isPrioritizeOnDemandEnabled(getMailboxInfo(tableView)) &&
        isPriorityView(tableView?.tableQuery as MailFolderTableQuery)
    );
}
